export default {
  keepEmptyLines(text: string): string {
    if (text) {
      return text.replace(/<p><\/p>/g, '<p><br/></p>');
    }
    return text;
  },
};
